<div class="card rounded-12 border-0 mb-3">
  <div class="card-body d-flex flex-column">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <h4>{{ "honorboard" | translate }}</h4>
      </div>
      <div class="d-flex gap-2 align-items-center">
        <div>
          <button
            (click)="deleteFilter()"
            class="btn myPadding rounded-m rounded-8 btn btn-secondary d-flex gap-2"
            type="button"
          >
            {{ "filtrationDelete" | translate }}
          </button>
        </div>
        <div class="form-floating">
          <input
            type="email"
            class="form-control bg-info-o"
            id="input1"
            placeholder="date"
            bsDaterangepicker
            [maxDate]="maxDate"
            [formControl]="date"
            [bsConfig]="{
              containerClass: 'theme-red',
              isAnimated: true,
              showWeekNumbers: false,
              adaptivePosition: true
            }"
          />
          <label for="input1" translate="date_range"></label>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card cardImg rounded-12 border-0 mb-3">
  <div class="card-body d-flex flex-column">
    <div class="row p-4">
      <div class="col-4 bg-white">
        <div class="honorCard">
          <h4 class="honorTitle">{{ "clients.guards" | translate }}</h4>
          <div class="table-responsive text-primary">
            <table class="table ">
              <thead>
                <th>
                  <div class="text">{{ "name" | translate }}</div>
                </th>
                <th>
                  <div class="text">{{ "total_work_hours" | translate }}</div>
                </th>
                <th>
                  <div class="text">{{ "total_work_day" | translate }}</div>
                </th>
              </thead>
              <tbody>
                <ng-container>
                  <tr *ngFor="let guard of top5AttendanceGuard">
                    <td>{{ guard.guardName }}</td>
                    <td>{{ guard.totalhours }}</td>
                    <td>{{ guard.totalWorkingDayes }}</td>
                  </tr>
                </ng-container>
                <tr *ngIf="!top5AttendanceGuard?.length">
                  <td colspan="13">
                    <h6
                      class="text-align-center my-5 fw-500 text-danger"
                      translate="no_data_to_show"
                    ></h6>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-4 bg-white">
        <div class="honorCard">
          <h4 class="honorTitle">{{ "supervisor" | translate }}</h4>
          <div class="table-responsive text-primary">
            <table class="table">
              <thead>
                <th>
                  <span class="text">{{ "name" | translate }}</span>
                </th>
                <th>
                  <span class="text">{{ "total_work_day" | translate }}</span>
                </th>
              </thead>
              <tbody>
                <ng-container>
                  <tr *ngFor="let supervisor of top5SupervisorAttendance">
                    <td>{{ supervisor.name }}</td>
                    <td>{{ supervisor.total }}</td>
                  </tr>
                </ng-container>
                <tr *ngIf="!top5SupervisorAttendance?.length">
                  <td colspan="13">
                    <h6
                      class="text-align-center my-5 fw-500 text-danger"
                      translate="no_data_to_show"
                    ></h6>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-4 bg-white">
        <div class="honorCard">
          <h4 class="honorTitle">{{ "more-productive" | translate }}</h4>
          <div class="table-responsive text-primary">
            <table class="table">
              <thead>
                <th>
                  <span class="text">{{ "name" | translate }}</span>
                </th>
                <th>
                  <span class="text">{{ "mission" | translate }}</span>
                </th>
              </thead>
              <tbody>
                <ng-container>
                  <tr *ngFor="let productive of top5ProductiveGuard">
                    <td>{{ productive.guardName }}</td>
                    <td>{{ productive.total }}</td>
                  </tr>
                </ng-container>
                <tr *ngIf="!top5ProductiveGuard?.length">
                  <td colspan="13">
                    <h6
                      class="text-align-center my-5 fw-500 text-danger"
                      translate="no_data_to_show"
                    ></h6>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
